import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Hero = ({ name = 'Your Name', role = 'Web Developer', summary = 'I build delightful web experiences with React, Next.js, and modern tooling.', socials = {} }) => {
  const { github = '#', linkedin = '#', email = 'mailto:you@example.com' } = socials;

  return (
    <header id="home" className="hero">
      <div className="hero-inner">
        <motion.p
          className="eyebrow"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Hello, I am
        </motion.p>
        <motion.h1
          className="title huge gradient-text"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.7 }}
        >
          {name}
        </motion.h1>
        <motion.h2
          className="subtitle"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.7 }}
        >
          {role}
        </motion.h2>
        <motion.p
          className="lead"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
        >
          {summary}
        </motion.p>

        <motion.div
          className="hero-cta"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.7 }}
        >
          <a className="btn primary" href="#projects">View Projects</a>
          <a className="btn ghost" href="#contact">Contact Me</a>
        </motion.div>

        <motion.div
          className="socials"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.7 }}
        >
          <a href={github} target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub /></a>
          <a href={linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
          <a href={email} aria-label="Email"><FaEnvelope /></a>
        </motion.div>
      </div>
    </header>
  );
};

export default Hero;
